import { useState } from 'react';
import { toast } from '@cencosud-cencommerce/paris-uikit';

import { useRepository } from '@/Application/Providers/Repository';
import type { Address } from '@/modules/address/domain/Address';
import { saveAddress } from '@/modules/customer/application/saveAddress';
import { useCustomerContext } from '@/sections/customer/CustomerContext';
import { getPayloadForCustomerAddress } from '@/sections/customer/hooks/utils';
import { usePlaceData } from '@/sections/region/GooglePlaceDataContext';

const useCreateCustomerAddress = () => {
  const { customerRepository } = useRepository();
  const { setData } = useCustomerContext();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { placeData } = usePlaceData();

  const trigger = async (address: Address) => {
    setIsLoading(true);

    const addressPayload = getPayloadForCustomerAddress(address, placeData);

    try {
      const updatedCustomer = await saveAddress(
        customerRepository,
        addressPayload
      );
      setData(updatedCustomer);
      setIsLoading(false);
    } catch (e) {
      toast({
        status: 'error',
        title: 'Error al guardar la dirección del usuario'
      });
      setError((e as Error).message);
    }
  };

  return { trigger, isLoading, error };
};

export default useCreateCustomerAddress;
